module.exports = __webpack_public_path__ + "img/info-icon.6626f443.svg";